import { render, staticRenderFns } from "./MInput.vue?vue&type=template&id=6c85b397"
import script from "./MInput.vue?vue&type=script&lang=js"
export * from "./MInput.vue?vue&type=script&lang=js"
import style0 from "./MInput.vue?vue&type=style&index=0&id=6c85b397&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports